import { createRoute } from '@tanstack/react-router';
import { Suspense } from 'react';
import { GeneralSpinner } from '@Components/generalSpinner';
import { RoutesMap } from '@Router/router.types';
import { routesModel } from '@Router/router.consts';
import { RecoveryRoot } from '@Pages/recoveryPages/RecoveryRoot';
import { ResetPasswordRequest } from '@Pages/recoveryPages/ResetPasswordRequest';
import { SecurityQuestion } from '@Pages/recoveryPages/SecurityQuestion';
import { beforeLoadGeneral } from '@Router/middleware';
import { VerificationCode } from '@Pages/recoveryPages/VerificationCode';
import { RecoveryType } from '@Pages/recoveryPages/RecoveryType';
import { RecoverySetPassword } from '@Pages/recoveryPages/RecoverySetPassword';
import { RecoverySuccess } from '@Pages/recoveryPages/RecoverySuccess';
import { useBoundStore } from '@Store/useBoundStore';
import { router } from '@Routes/__root';
import { rootRoute } from './rootRoute';
const RecoveryRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: routesModel[RoutesMap.RECOVERY].path,
  beforeLoad: () => {
    beforeLoadGeneral({ page: RoutesMap.RECOVERY, shouldUpdateServerNavStack: false });
  },
  component: () => (
    <Suspense fallback={<GeneralSpinner />}>
      <RecoveryRoot />
    </Suspense>
  ),
});

const ResetPasswordRequestRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: routesModel[RoutesMap.RESET_PASSWORD_REQUEST].path,
  beforeLoad: () => {
    beforeLoadGeneral({
      page: RoutesMap.RESET_PASSWORD_REQUEST,
      shouldUpdateServerNavStack: false,
    });
  },
  component: () => <ResetPasswordRequest />,
});

const SecurityQuestionRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: routesModel[RoutesMap.SECURITY_QUESTION].path,
  beforeLoad: () => {
    beforeLoadGeneral({ page: RoutesMap.SECURITY_QUESTION, shouldUpdateServerNavStack: false });
  },
  component: () => <SecurityQuestion />,
});

const VerificationCodeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: routesModel[RoutesMap.RECOVERY_VERIFICATION_CODE].path,
  beforeLoad: () => {
    const { requestMfaType } = useBoundStore.getState().resetPasswordSlice;

    if (!requestMfaType) {
      // Redirect to start of the recovery flow if requestMfaType is not set
      throw router.navigate({ to: routesModel[RoutesMap.RESET_PASSWORD_REQUEST].path });
    }

    beforeLoadGeneral({
      page: RoutesMap.RECOVERY_VERIFICATION_CODE,
      shouldUpdateServerNavStack: false,
    });
  },
  component: () => <VerificationCode />,
});

const RecoveryTypeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: routesModel[RoutesMap.RECOVERY_TYPE].path,
  beforeLoad: () => {
    beforeLoadGeneral({ page: RoutesMap.RECOVERY_TYPE, shouldUpdateServerNavStack: false });
  },
  component: () => <RecoveryType />,
});

const RecoverySetPasswordRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: routesModel[RoutesMap.RECOVERY_SET_PASSWORD].path,
  beforeLoad: () => {
    beforeLoadGeneral({ page: RoutesMap.RECOVERY_SET_PASSWORD, shouldUpdateServerNavStack: false });
  },
  component: () => <RecoverySetPassword />,
});

const RecoverySuccessRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: routesModel[RoutesMap.RECOVERY_SUCCESS].path,
  component: () => <RecoverySuccess />,
});

export const recoveryRoutes = [
  RecoveryRoute,
  ResetPasswordRequestRoute,
  SecurityQuestionRoute,
  VerificationCodeRoute,
  RecoveryTypeRoute,
  RecoverySetPasswordRoute,
  RecoverySuccessRoute,
];
